<form [formGroup]="userForm" autocomplete='off'>
    <div class="row">
        <div class="col-sm-4">
            <div class="form-group">
                <label for="">{{ 'PASSWORD' | translate }}</label>
                <input type="password" required class="form-control form-control-sm" formControlName="password" #passwordData>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="form-group">
                <label for="">{{ 'NEWPASSWORD' | translate }}</label>
                <input type="password" required class="form-control form-control-sm" formControlName="newPassword">
            </div>
        </div>
        <div class="col-sm-4">
            <div class="form-group">
                <label for="">{{ 'REPASSWORD' | translate }}</label>
                <input type="password" required class="form-control form-control-sm" name="confirmPassword" formControlName="confirmPassword"
                    validateEqual="newPassword" reverse="false">
            </div>
        </div>
    </div>

    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <btns-ctrl [disabled]="userForm.invalid && passwordData" [paramsArr]="controlsParams" (clicked)="onClicked($event)"></btns-ctrl>
            </div>
        </div>
    </div>
</form>